export default __webpack_public_path__ + "static/usa-flag-background-7888d5cd11187bcfbf5da41f81037db8.jpg";